<template>
  <div>
    <v-expansion-panels multiple>
      <v-expansion-panel
        v-for="article in articles"
        :title="article.headline"
      >
        <v-expansion-panel-text>
          <!-- this div will contain html -->
          <div v-html="article.content"></div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'VProducts',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    articles () {
      return this.value
    }
  }
}
</script>
